import { useTranslation } from "react-i18next";

export default function SpoedBanner() {
  const { t } = useTranslation("slot-cilinder-vervangen");

  return (
    <section className="bg-brand-yellow w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-5 md:py-6">
        <a
          href="tel:+31407987470"
          className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-center"
        >
          <span className="font-geist font-bold text-base md:text-lg text-brand-text whitespace-nowrap">
            {t("spoedBanner.text")}
          </span>
        </a>
      </div>
    </section>
  );
}